import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { logo, ClockIcon, MailIcon, PhoneNumIcon, TwitterIcon, FacebookIcon, LinkedinIcon, YoutubeIcon, UserIcon } from "../imagepath";
import styles from './header.module.css';


const Header = () => {
    useEffect(() => {
        document.body?.classList?.remove("menu-opened");
        return () => {
            document.body.className = "";
        };
    }, []);

    const [navbar, setNavbar] = useState(false);

    const openMobileMenu = () => {
        document.body?.classList?.add("menu-opened");
    };
    const hideMobileMenu = () => {
        document.body?.classList?.remove("menu-opened");
    };
    const changeHeaderBackground = () => {
        if (window.scrollY >= 90) {
            setNavbar(true);
        } else {
            setNavbar(false);
        }
    };

    window.addEventListener("scroll", changeHeaderBackground);

    return (
        <header className={styles.header_sticky}>
            <div>
                <nav
                    className={styles.header_main}
                >
                    <div className={`d-flex flex-row align-items-center ${styles.header_top}`}>
                        <div className={`d-flex flex-row justify-content-between ${styles.header_top_left}`}>
                            <div className="d-flex flex-row justify-content-center align-items-center">
                                <div className="d-flex flex-row gap-1 pe-4 align-items-center">
                                    <PhoneNumIcon className={`${styles.header__noneOn560}`}/>
                                    <p className={`text-white h6 m-0 ps-2 ${styles.header__noneOn768}`}>+1 800-381-6794</p>
                                </div>
                                <div className="d-flex flex-row gap-1 pe-4 align-items-center">
                                    <MailIcon className={`${styles.header__noneOn560}`}/>
                                    <p className={`text-white h6 m-0 ps-2 ${styles.header__noneOn560}`}>Edu@AngelWatch.org</p>
                                </div>
                                <div className={`d-flex flex-row gap-1 pe-4 align-items-center ${styles.header__noneOn768}`}>
                                    <ClockIcon className={`${styles.header__noneOn560}`}/>
                                    <p className={`text-white h6 m-0 ps-2 ${styles.header__noneOn1024}`}>Everyday 8:00 - 20:00 </p>
                                </div>
                            </div>
                        </div>
                        <Link className="d-flex flex-row ps-2" to="/login">
                            <UserIcon/>
                            <p className="text-white h6 m-0 ps-2">LogIn</p>
                            <p className="text-white h6 m-0 ps-2">/</p>
                            <p className="text-white h6 m-0 ps-2">Register</p>
                        </Link>
                    </div>
                </nav>
            </div>
        </header>
    )
};

export default Header;



/*

<div className="navbar-header">
                            <Link id="mobile_btn" to={process.env.REACT_APP_URL || "/"} onClick={openMobileMenu}>
                                <span className="bar-icon">
                                <span />
                                <span />
                                <span />
                                </span>
                            </Link>
                            <Link to={process.env.REACT_APP_URL || "/"} className="navbar-brand logo">
                                <img src={logo} className="img-fluid" alt="Logo" />
                            </Link>
                        </div>
                        <div className="main-menu-wrapper">
                            <div className="menu-header">
                                <Link to={process.env.REACT_APP_URL || "/"} className="menu-logo">
                                    <img src={logo} className="img-fluid" alt="Logo" />
                                </Link>
                                <Link
                                    id="menu_close"
                                    className="menu-close"
                                    to={process.env.REACT_APP_URL || "/"}
                                    onClick={hideMobileMenu}
                                >
                                    <i className="fas fa-times" />
                                </Link>
                            </div>
                            <ul className="main-nav">
                                <li className="has-submenu active">
                                    <Link
                                        className="submenu"
                                        to={process.env.REACT_APP_URL || "/"}
                                    >
                                        Home
                                    </Link>
                                </li>
                                <li className="login-link">
                                    <Link to="/login">Login / Signup</Link>
                                </li>
                            </ul>
                        </div>
                        <ul className="nav header-navbar-rht">
                            <DarkMode/>
                            <li className="nav-item">
                                <Link className="nav-link header-sign" to="/login">
                                Signin
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link header-login" to="/selectregister">
                                Signup
                                </Link>
                            </li>
                        </ul>

*/